var feeJS = feeJS || {};
feeJS.execFactory = (execParams) => {
  for (const [object, params] of Object.entries(execParams)) {
    feeJS[object](params);
  }
}



feeJS.classFactory = (classList, classParams) => {
  for (const [object, params] of Object.entries(classParams)) {
    if (!String(Object.values(classList)).includes(object)) continue;
    classList[object].init(params);
  }
}



feeJS.listenerFactory = (listenParams) => {
  for (const [object, params] of Object.entries(listenParams)) {
    feeJS.bindEvent(params['event'], params['selector'], feeJS[object]);
  }
}